var _desc, _path, _path2, _g, _g2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _polygon, _polygon2, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServicerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 187 140",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Contact") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "servicerIconHWA0",
    d: "m101.1 105.5l0.4-0.1 8.1 3.7-0.5-9.1 0.2-0.3c2.2-2.7 3.7-5.9 4.3-9.3 1.9-10.8-5.3-21.1-16-23-5.3-0.9 0.7-0.6 1.4 7.9s-0.2 13.8-3.3 18.7c-5.3 8.2-15.8 10.6-5.1 12.5 3.6 0.6 7.2 0.2 10.5-1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "servicerIconHWA1",
    d: "m101.6 106.5l7.6 3.4c0.8 0.4 1.8-0.3 1.8-1.2v-8.5c3.2-3.8 5-8.5 5-13.5 0-4.4-1.3-8.5-3.9-12.1-1-1.3-3 0.2-2.1 1.5 2.2 3.1 3.4 6.8 3.4 10.6 0 4.5-1.7 8.8-4.7 12.1-0.2 0.2-0.3 0.5-0.3 0.8v7l-6.3-2.8c-0.3-0.1-0.6-0.1-0.9 0-2 0.7-4.1 1.1-6.2 1.1-10.2 0-18.5-8.2-18.5-18.2s8.3-18.2 18.5-18.2c3.8 0 7.4 1.1 10.5 3.3 1.3 0.9 2.8-1.2 1.4-2.1-3.5-2.4-7.7-3.7-12-3.7-11.6 0-21 9.3-21 20.8s9.4 20.8 21 20.8c2.3 0 4.6-0.4 6.7-1.1z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(55 10)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "servicerIconHWA2",
    d: "m5.7 6.8c-0.5 0-1 0.4-1 1v2.2c0 0.5 0.4 1 1 1s1-0.4 1-1v-2.2c-0.1-0.6-0.5-1-1-1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "servicerIconHWA2",
    d: "m3.2 4.6h-2.2c-0.5 0-1 0.4-1 1s0.4 1 1 1h2.2c0.5 0 1-0.4 1-1s-0.5-1-1-1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "servicerIconHWA2",
    d: "M5.7,0c-0.5,0-1,0.4-1,1v2.2c0,0.5,0.4,1,1,1s1-0.4,1-1V1C6.6,0.4,6.2,0,5.7,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "servicerIconHWA2",
    d: "m10.4 4.4h-2.2c-0.5 0-1 0.4-1 1s0.4 1 1 1h2.2c0.5 0 1-0.4 1-1s-0.5-1-1-1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(168 100)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "servicerIconHWA2",
    d: "M9.5,12C8.7,12,8,12.7,8,13.6v3.8C8,18.3,8.7,19,9.5,19s1.5-0.7,1.5-1.6v-3.8C11,12.7,10.3,12,9.5,12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "servicerIconHWA2",
    d: "M5.4,8H1.6C0.7,8,0,8.7,0,9.5S0.7,11,1.6,11h3.8C6.3,11,7,10.3,7,9.5S6.3,8,5.4,8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "servicerIconHWA2",
    d: "M9.5,0C8.7,0,8,0.7,8,1.6v3.8C8,6.3,8.7,7,9.5,7S11,6.3,11,5.4V1.6C11,0.7,10.3,0,9.5,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "servicerIconHWA2",
    d: "M17.4,8h-3.8C12.7,8,12,8.7,12,9.5s0.7,1.5,1.6,1.5h3.8c0.9,0,1.6-0.7,1.6-1.5S18.3,8,17.4,8"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "servicerIconHWA2",
    d: "m9.6 109s1.3 9.3-9.6 9.1c0 0 9.3 0.1 9.1 8.8 0 0 0.8-6.9 9.4-8.4 0 0-7.2 1.7-8.9-9.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "servicerIconHWA0",
    d: "m158.6 38s1.3 9.3-9.6 9.1c0 0 9.3 0.1 9.1 8.8 0 0 0.8-6.9 9.4-8.4 0 0-7.2 1.7-8.9-9.5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "servicerIconHWA0",
    d: "m66.2 122s0.7 5.2-5.2 5.1c0 0 5 0.1 4.9 4.9 0 0 0.5-3.8 5.1-4.7 0 0-3.9 0.9-4.8-5.3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "servicerIconHWA2",
    d: "m27.3 61s0.5 3.2-3.3 3.2c0 0 3.3 0 3.2 3.1 0 0 0.3-2.4 3.3-2.9 0-0.1-2.6 0.5-3.2-3.4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "servicerIconHWA1",
    d: "m119 6c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3zm0-5c-1.1 0-2 0.9-2 2s0.9 2 2 2 2-0.9 2-2-0.9-2-2-2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "servicerIconHWA3",
    d: "M2.5,30C1.1,30,0,28.9,0,27.5S1.1,25,2.5,25S5,26.1,5,27.5S3.9,30,2.5,30z M2.5,26C1.7,26,1,26.7,1,27.5  S1.7,29,2.5,29S4,28.3,4,27.5S3.3,26,2.5,26z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "servicerIconHWA4",
    d: "m100.5 138h-11c-1.9 0-3.5-1.2-3.5-2.6v-3.4c0.2 1.3 1.7 2.4 3.5 2.4h11c1.8 0 3.3-1 3.5-2.4v3.4c0 1.4-1.6 2.6-3.5 2.6z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "servicerIconHWA0",
    points: "135 70.6 135 105 139.7 105 145.4 105 149 100 149 93.2 149 80.5 149 74.5 145.4 70.6 139.7 69 135 69"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "servicerIconHWA0",
    points: "55 70.6 55 105 50.3 105 44.6 105 41 100 41 93.2 41 80.5 41 74.5 44.6 70.6 50.3 69 55 69"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "servicerIconHWA1",
    d: "m141.7 67.5c-4-21.6-24-37.8-46.7-37.8s-42.7 16.2-46.7 37.8c-4.9 0.9-8.6 5.3-8.6 10.3v5.3c0 2.5 3.9 2.5 3.9 0v-5.3c0-3.6 3-6.5 6.6-6.5h3v32.7h-3c-3.6 0-6.6-2.9-6.6-6.5v-6.2c0-2.5-3.9-2.5-3.9 0v6.2c0 5.8 4.7 10.4 10.5 10.4h3.5c1.1 0 3.6-0.2 3.6-1.7v-37.3c-0.1-0.7-0.8-1.6-3.6-1.6h-1.4c4-19.3 22.3-33.7 42.7-33.7s38.7 14.5 42.7 33.7h-1.4c-2.1 0-4 0-4 1.7v37.3c0.1 0.5 0.4 0.9 0.8 1.2 1.2 0.8 3.2 0.4 3.2 0.4h1.4c-2.9 14.2-15.7 24.5-31.4 25.1-0.8-2.1-2.8-3.4-5.1-3.4h-12.4c-3 0-5.5 2.5-5.5 5.4s2.5 5.4 5.5 5.4h12.3c2.3 0 4.3-1.4 5.1-3.5 17.7-0.6 32.6-12.8 35.4-29.2 5-0.9 8.7-5.3 8.7-10.3v-19.7c0-5-3.6-9.4-8.6-10.2zm4 10.3v19.4c0 3.5-2.9 6.4-6.4 6.4h-2.9v-32.3h2.9c3.5 0 6.4 2.9 6.4 6.5zm-43 56.7c0 0.6-0.5 1.2-1.5 1.2h-12.4c-1 0-1.5-0.6-1.5-1.2s0.5-1.2 1.5-1.2h12.3c1.1 0 1.6 0.6 1.6 1.2z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "servicerIconHWA1",
    d: "m103.4 84.2c0 4.9-3.5 8.8-7.8 8.8s-7.8-3.9-7.8-8.8h-2.1c0 6 4.4 10.9 9.9 10.9s9.9-4.9 9.9-10.9h-2.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicerIcon);
export default __webpack_public_path__ + "static/media/Servicer_Icon.d76e37815b14e49291354b8baf539422.svg";
export { ForwardRef as ReactComponent };